import { render, staticRenderFns } from "./NewInvoiceView.vue?vue&type=template&id=60e195c9"
import script from "./NewInvoiceView.vue?vue&type=script&lang=js"
export * from "./NewInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports